import { render, staticRenderFns } from "./Modification.vue?vue&type=template&id=5446c8d8&"
import script from "./Modification.vue?vue&type=script&lang=ts&"
export * from "./Modification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports